<dx-popup
    #reimbursementEditorPopup
    minWidth="150px"
    minHeight="150px"
    width="65%"
    height="85%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupClose()"
>
    <div *dxTemplate="let data of 'content'" id="reimbursementEditorBox">
        <dx-box width="100%" height="100%" direction="col" class="editor-box-container">
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-form *ngIf="reimbursementEditor" width="100%" height="100%" [colCount]="2" class="editor-form">
                        <dxi-item>
                            <dxo-label text="Management Company"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box
                                    [readOnly]="true"
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="reimbursementEditor.managementCompany"
                                ></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Community"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box
                                    [readOnly]="true"
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="reimbursementEditor.community"
                                ></dx-text-box>
                            </div>
                        </dxi-item>
                        <dxi-item isRequired="true">
                            <dxo-label text="Source Bank Account"></dxo-label>
                            <div *dxTemplate>
                                <app-multi-column-selector
                                    [name]="'Source Bank Account'"
                                    [gridSource]="reimbursementEditor.sourceBankAccounts"
                                    [boxValue]="sourceBankAccountBoxValue"
                                    [valueExpr]="'bankAccountId'"
                                    [displayExpr]="'accountName'"
                                    [columnDef]="bankAccountColumns"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 'auto' }"
                                    [showClearButton]="true"
                                    [placeholder]="'Select Source Account'"
                                    (gridSelectionEvent)="onSourceAccountSelection($event)"
                                ></app-multi-column-selector>
                            </div>
                        </dxi-item>
                        <dxi-item isRequired="true">
                            <dxo-label text="Bank Account"></dxo-label>
                            <div *dxTemplate>
                                <app-multi-column-selector
                                    [name]="'Target Bank Account'"
                                    [gridSource]="reimbursementEditor.targetBankAccounts"
                                    [boxValue]="targetBankAccountBoxValue"
                                    [valueExpr]="'bankAccountId'"
                                    [displayExpr]="'accountName'"
                                    [columnDef]="bankAccountColumns"
                                    [dropDownButtonTemplate]="'dropDownButton'"
                                    [dropDownOptions]="{ width: 'auto' }"
                                    [showClearButton]="true"
                                    [placeholder]="'Select Target Account'"
                                    (gridSelectionEvent)="onTargetAccountSelection($event)"
                                ></app-multi-column-selector>
                            </div>
                        </dxi-item>
                        <dxi-item isRequired="true">
                            <dxo-label text="Post Date"></dxo-label>
                            <div *dxTemplate>
                                <dx-date-box
                                    type="date"
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="reimbursementRawDto.postDate"
                                ></dx-date-box>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Reimbursement Amount"></dxo-label>
                            <div *dxTemplate>
                                <dx-number-box
                                    [readOnly]="true"
                                    [showSpinButtons]="false"
                                    [(format)]="currencyFormat"
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="reimbursementRawDto.amount"
                                ></dx-number-box>
                            </div>
                        </dxi-item>
                        <dxi-item [colSpan]="2">
                            <dxo-label text="Description"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-box
                                    [elementAttr]="{ class: 'field-component' }"
                                    [(value)]="reimbursementRawDto.description"
                                ></dx-text-box>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>

            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <cc-data-grid-features
                        *ngIf="!!lineItemsSource"
                        [gridFeatures]="{ allowGrouping: false, allowPaging: false }"
                        [stateConfig]="{ storageKey: 'REIMBURSEMENT_EDITOR', storeGroupings: false }"
                        [dataSource]="lineItemsSource"
                        (onPlacementChange)="onPlacementChange($event)"
                    >
                        <dx-data-grid
                            #reimbursementEditorGrid
                            appHasInternalUserColumns
                            width="100%"
                            height="100%"
                            keyExpr="lineItemWorkflowId"
                            [selectedRowKeys]="selectedReimbursementKeys"
                            [dataSource]="lineItemsSource"
                            (onCellPrepared)="onCellPrepared($event)"
                            (onSelectionChanged)="onGridSelectionChange($event)"
                            (onToolbarPreparing)="onToolbarPreparing($event)"
                        >
                            <dxo-selection
                                mode="multiple"
                                selectAllMode="allPages"
                                showCheckBoxesMode="always"
                                [allowSelectAll]="false"
                            ></dxo-selection>

                            <div *dxTemplate="let buttonData of 'addReimbursementOptionsTemplate'">
                                <dx-select-box
                                    displayExpr="displayText"
                                    valueExpr="value"
                                    width="280px"
                                    [items]="lineitemFilterOptions"
                                    [(value)]="showReimbursableChargesOnly"
                                    (onValueChanged)="onLineItemsFilterOptionChange()"
                                ></dx-select-box>
                            </div>

                            <dxi-column
                                name="InternalActions"
                                type="buttons"
                                caption="Action"
                                headerCellTemplate="lockHeaderCellTemplate"
                                [width]="110"
                                [visibleIndex]="0"
                                [showInColumnChooser]="false"
                            >
                                <dxi-button template="template">
                                    <div *dxTemplate="let row of 'template'">
                                        <app-grid-actions-menu
                                            [actionMenuItems]="actionMenuItems"
                                            [record]="row.data"
                                            [rowIndex]="row.rowIndex"
                                            [isActionVisible]="isActionVisible"
                                            (onActionClick)="onActionClick($event)"
                                        ></app-grid-actions-menu>
                                    </div>
                                </dxi-button>
                            </dxi-column>

                            <dxi-column
                                dataType="number"
                                dataField="lineItemWorkflowId"
                                caption="Workflow Id"
                            ></dxi-column>
                            <dxi-column
                                dataType="date"
                                dataField="transactionDate"
                                caption="Transaction Date"
                                [format]="dateFormat"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="description" caption="Description"></dxi-column>
                            <dxi-column
                                dataType="number"
                                dataField="amount"
                                [format]="currencyFormat"
                                caption="Amount"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="invoiceNumber" caption="Invoice#"></dxi-column>
                            <dxi-column
                                alignment="center"
                                caption="Receipt"
                                cellTemplate="invoiceCellTemplate"
                            ></dxi-column>
                            <dxi-column dataType="string" dataField="glAccount" caption="GL Account"></dxi-column>
                            <dxi-column dataType="string" dataField="subCategory" caption="Sub Category"></dxi-column>
                            <dxi-column dataType="string" dataField="dimensions" caption="Dimensions"></dxi-column>

                            <div *dxTemplate="let header of 'lockHeaderCellTemplate'">
                                {{ header.column.caption }}
                                <app-security-info
                                    securityIndicator="LOCK"
                                    apiAction="GET"
                                    apiUrl="api/wf/reimbursement/editor"
                                ></app-security-info>
                            </div>

                            <div *dxTemplate="let d of 'invoiceCellTemplate'">
                                <ng-container *ngIf="!!d.data.invoiceFileInfo.downloadUrl">
                                    <i
                                        class="icon-content cc-1-5x cc-icon-pdf"
                                        [ngClass]="iconPDF"
                                        (click)="onDownloadFile(d.data)"
                                    ></i>
                                </ng-container>
                            </div>

                            <dxo-summary>
                                <dxi-total-item
                                    column="amount"
                                    name="amount"
                                    summaryType="sum"
                                    [customizeText]="customizeLineItemSummary"
                                ></dxi-total-item>
                            </dxo-summary>
                        </dx-data-grid>
                    </cc-data-grid-features>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <div class="button-container full-width">
                        <div class="full-width left-container">
                            <dx-button
                                type="default"
                                text="Cancel"
                                hint="Cancel"
                                [icon]="iconCancel"
                                (onClick)="onCancelClick()"
                            ></dx-button>
                        </div>

                        <div class="full-width right-container">
                            <dx-button
                                type="success"
                                text="Save"
                                hint="Save"
                                [disabled]="
                                    !!reimbursementRawDto.reimburseWorkflowIds &&
                                    reimbursementRawDto.reimburseWorkflowIds.length === 0
                                "
                                [icon]="iconSave"
                                (onClick)="onSaveClick()"
                            ></dx-button>
                        </div>
                    </div>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>

<app-attach-receipt
    *ngIf="showAttachmentReceipt"
    [lineItemWorkflowId]="selectedReimbursementLineItem.lineItemWorkflowId"
    [communityId]="communityId"
    (onClose)="onInvoiceUploaderClose($event)"
></app-attach-receipt>

<app-workflow-viewer
    *ngIf="showReclassify"
    [workflowId]="selectedReimbursementLineItem?.lineItemWorkflowId"
    [communityId]="apBillData?.communityId"
    [apBillDetailParam]="apBillDetailParam"
    (onClose)="onReclassifyClose($event)"
></app-workflow-viewer>

<dx-load-panel
    *ngIf="loadingVisible"
    [position]="{ of: '#reimbursementEditorBox' }"
    [visible]="loadingVisible"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false"
></dx-load-panel>
